export enum NotificationPreferenceCategory {
  PromptAvailabilityPreferenceCategory = 'PromptAvailabilityReminder',
  AvailabilityRequestedPreferenceCategory = 'availabilityRequest',
}

export enum NotificationPreferenceValue {
  Enabled = 'enabled',
  Disabled = 'disabled',
}

export interface NotificationPreferenceApiResponse {
  category?: string;
  enabled?: boolean | null;
  isEnabled?: boolean | null;
  value?: string | null;
  status?: string | null;
  preference?: string | null;
}
